import { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { MdCalendarToday } from "react-icons/md";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import SwipeDatePicker from "../swipeComp/SwipeDatePicker";

const DatePickerInput = ({
  value,
  onChange,
  error,
  helperText,
  onBlur,
  placeholder = "DD/MM/YYYY",
  maxDate = new Date(),
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const handleDateChange = (newDate) => {
    onChange(newDate);
    setTouched(true);
  };

  const handleBlur = () => {
    setTouched(true);
    if (onBlur) onBlur();
  };

  const handleOpen = () => {
    if (isMobile) {
      setIsOpen(true);
    }
  };

  const desktopStyles = {
    backgroundColor: "white",
    borderRadius: "10px",
    color: "#111827",
    transition: "all 0.4s",
    fontFamily: '"Montserrat", sans-serif',
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: error ? "#ef4444" : "#d1d5db",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? "#ef4444" : "#9ca3af",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? "#ef4444" : "#111827",
      borderWidth: "1px",
    },
    "& .MuiInputBase-input": {
      padding: "14px 12px",
      color: "#111827",
      fontSize: { xs: "14px", lg: "16px" },
      fontFamily: '"Montserrat", sans-serif',
      "&::placeholder": {
        color: "#CBCBCB",
        opacity: 1,
        fontFamily: '"Montserrat", sans-serif',
      },
    },
  };

  if (!isMobile) {
    return (
      <DatePicker
        slotProps={{
          textField: {
            fullWidth: true,
            placeholder: placeholder,
            InputProps: {
              sx: desktopStyles,
            },
            FormHelperTextProps: {
              sx: {
                width: "100%",
                display: "flex",
                justifyContent: "end",
                margin: "2px 0 0 0",
                fontSize: "12px",
                color: "#ef4444",
                fontFamily: '"Montserrat", sans-serif',
              },
            },
            error: error || (touched && !value),
            helperText:
              helperText ||
              (touched && !value ? "Tanggal lahir wajib diisi" : ""),
          },
        }}
        sx={{
          width: "100%",
        }}
        value={value ? moment(value, "YYYY-MM-DD") : null}
        onChange={(date) => {
          handleDateChange(date ? moment(date).format("YYYY-MM-DD") : "");
        }}
        onBlur={handleBlur}
        format="DD/MM/YYYY"
        maxDate={moment(maxDate)}
      />
    );
  }

  return (
    <>
      <div className="relative">
        <TextField
          fullWidth
          placeholder={placeholder}
          value={formatDate(value)}
          onClick={handleOpen}
          onBlur={handleBlur}
          error={error || (touched && !value)}
          helperText={
            helperText || (touched && !value ? "Tanggal lahir wajib diisi" : "")
          }
          InputProps={{
            readOnly: true,
            sx: desktopStyles,
          }}
          FormHelperTextProps={{
            sx: {
              width: "100%",
              display: "flex",
              justifyContent: "start",
              margin: "2px 0 0 0",
              fontSize: "12px",
              color: "#ef4444",
              fontFamily: '"Montserrat", sans-serif',
            },
          }}
        />
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <MdCalendarToday className="text-gray-400" />
        </div>
      </div>

      <SwipeDatePicker
        open={isOpen}
        onClose={() => setIsOpen(false)}
        value={value}
        onChange={handleDateChange}
        maxDate={maxDate}
      />
    </>
  );
};

export default DatePickerInput;
